<template>
  <div class="content-loader-placeholder" v-if="noContent">
    <analytics-unit-block-loader v-if="type === 'AnalyticsUnitBlock'"></analytics-unit-block-loader>

    <audience-profile-loader v-if="type === 'AudienceProfileLoader'"></audience-profile-loader>
    <div v-if="type === 'AnalyticsHeatMapLoader'">
      <content-loader
        :height="Math.abs(sizeReducer[1])"
        :width="Math.abs(sizeReducer[0])"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect x="71" y="20" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="257" y="38" rx="0" ry="0" width="0" height="0" />
        <rect x="169.02" y="20" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="265.39" y="20" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="361.78" y="20" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="72.64" y="114.75" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="169.02" y="114.75" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="265.39" y="114.75" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="361.78" y="114.75" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="72.64" y="207.86" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="169.02" y="207.86" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="265.39" y="207.86" rx="0" ry="0" width="88.51" height="86.87" />
        <rect x="361.78" y="207.86" rx="0" ry="0" width="88.51" height="86.87" />
      </content-loader>
    </div>
    <word-cloud-loader v-if="type === 'WordCloudLoader'"></word-cloud-loader>
    <time-series-graph-loader v-if="type === 'TimeSeriesGraphLoader'"></time-series-graph-loader>
    <list-divider-loader v-if="type === 'ListDividerLoader'"></list-divider-loader>
    <engagement-graph-loader v-if="type === 'EngagementGraphLoader'"></engagement-graph-loader>
    <programming-dashboard-unit-loader v-if="type === 'ProgrammingDashboardUnitLoader'"></programming-dashboard-unit-loader>
    <analytics-chart-loader v-if="type === 'AnalyticsChartLoader'"></analytics-chart-loader>
    <doughnut-chart-loader v-if="type === 'DoughnutChartLoader'"></doughnut-chart-loader>
    <polar-chart-loader v-if="type === 'PolarChartLoader'"></polar-chart-loader>
    <advertisers-chart-loader v-if="type === 'AdvertisersChartLoader'"></advertisers-chart-loader>
  </div>
  <span v-else>
    <content-placeholder
      style="width: 100%; min-height: 200px; display: block;"
      slot="unit-content"
      text-value="Not enough data available"
      :text-array="
        !noContent && ['Not enough data available.', 'Try running some Competition campaigns.']
      "
      :text-only="true"
      :count="1"
    />
  </span>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';
import ContentPlaceholder from '@/components/common/ContentPlaceholder';
import AnalyticsUnitBlockLoader from '@/components/common/content-loaders/AnalyticsUnitBlockLoader';
import AudienceProfileLoader from '@/components/common/content-loaders/AudienceProfileLoader';
import AnalyticsHeatMapLoader from '@/components/common/content-loaders/AnalyticsHeatMapLoader';
import AnalyticsChartLoader from '@/components/common/content-loaders/AnalyticsChartLoader';
import DoughnutChartLoader from '@/components/common/content-loaders/DoughnutChartLoader';
import WordCloudLoader from '@/components/common/content-loaders/WordCloudLoader';
import TimeSeriesGraphLoader from '@/components/common/content-loaders/TimeSeriesGraphLoader';
import ListDividerLoader from '@/components/common/content-loaders/ListDividerLoader';
import AdvertisersChartLoader from '@/components/common/content-loaders/AdvertisersChartLoader';
import EngagementGraphLoader from '@/components/common/content-loaders/EngagementGraphLoader';
import PolarChartLoader from '@/components/common/content-loaders/PolarChartLoader';
import ProgrammingDashboardUnitLoader from '@/components/common/content-loaders/ProgrammingDashboardUnitLoader';
import IBox from '@/components/common/IBox';

export default {
  name: 'ContentLoaderPlaceholder',
  props: {
    type: {
      type: String,
      default: () => '',
    },

    fadeAfter: {
      type: Number,
      default: () => 12 * 3600,
    },
    contentVisible: {
      type: Boolean,
      default: false,
    },

    textArray: {
      type: Array,
    },
  },
  components: {
    IBox,
    AnalyticsUnitBlockLoader,
    AudienceProfileLoader,
    AnalyticsHeatMapLoader,
    AnalyticsChartLoader,
    WordCloudLoader,
    TimeSeriesGraphLoader,
    ListDividerLoader,
    EngagementGraphLoader,
    ContentLoader,
    ContentPlaceholder,
    ProgrammingDashboardUnitLoader,
    DoughnutChartLoader,
    PolarChartLoader,
    AdvertisersChartLoader,
  },
  data() {
    return {
      sizeReducer: [600, 500],
      noContent: true,
      clearInterval: null,
    };
  },
  mounted() {
    window.addEventListener('resize', this.getResolution);
    /*
      3. Hide Component after 30 seconds
      2. Check Content is still empty after 30
      1. Start 30s count down
    */
    this.clearInterval = setInterval(() => {
      /* eslint-disable */
      this.noContent = !this.noContent;

      this.$emit('onNoContent', this.noContent);
    }, this.fadeAfter);

    this.checkContentVisible(this.clearInterval);
  },

  methods: {
    getResolution(e) {
      const yHeight = e.currentTarget.outerHeight;
      const xWidth = e.currentTarget.outerWidth;
      const scalar = window.devicePixelRatio;

      this.sizeReducer = [yHeight / scalar, xWidth / scalar];
    },
    checkContentVisible(clearIntervalStop) {
      return this.contentVisible ? clearInterval(clearIntervalStop) : 'Not Content Visible';
    },
  },
};
</script>
<style lang="scss" scoped>
.content-loader-placeholder {
  &:hover {
  }
}
</style>



// WEBPACK FOOTER //
// ContentLoaderPlaceholder.vue?678797ee